import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { useTheme } from '../../../../../theming/useTheme';
import { LinkWithSubMenu } from './LinkWithSubMenu';
import { RegularHeaderLink } from './RegularHeaderLink';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';
import { NavigationLink } from '../primaryHeader/PrimaryHeader';

interface LinkListProps {
  links: NavigationLink[];
  pagePath: string;
  activeStateColor: string;
  hoverStateColor: string;
  idleColor: string;
  linkDropdownIconColor: string;
  onMenuToggle: (element: HTMLElement, index: number) => void;
  linkFontSizeLarge: TypographySize;
  linkFontSizeMedium: TypographySize;
  linkFontSizeSmall: TypographySize;
}

const getLinksStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  li: {
    display: 'inline-block',
    position: 'relative',
    whiteSpace: 'nowrap',
    ':not(:first-child)': {
      marginLeft: `${baseUnit}px`,
    },
    ':last-child': {
      [MEDIA_BREAKPOINTS.medium]: {
        marginRight: `${baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginRight: `${baseUnit}px`,
      },
    },
    ':first-child': {
      [MEDIA_BREAKPOINTS.medium]: {
        marginLeft: `${baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        marginLeft: `${baseUnit}px`,
      },
    },
  },
});

export const LinkList: React.FunctionComponent<LinkListProps> = props => {
  const { links, pagePath, activeStateColor, hoverStateColor, idleColor, onMenuToggle, linkDropdownIconColor, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall } = props;
  const { baseUnit } = useTheme();
  const fontStyles = { linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall };

  return (
    <React.Fragment>
      {
        links && links.map((navigationLink, index) => {
          const isActive = pagePath === navigationLink.link.href;
          const style = getLinksStyle(baseUnit);
          const hasSubMenu = (navigationLink.children || []).length > 0;

          return (
            <li key={index} className={css(style.li)}>
              {
                hasSubMenu
                  ? <LinkWithSubMenu title={navigationLink.link.text} hoverStateColor={hoverStateColor} idleColor={idleColor} toggleMenu={onMenuToggle} index={index} linkDropdownIconColor={linkDropdownIconColor} {...fontStyles} />
                  : <RegularHeaderLink activeStateColor={activeStateColor} hoverStateColor={hoverStateColor} idleColor={idleColor} isActive={isActive} href={navigationLink.link.href} text={navigationLink.link.text} {...fontStyles} />
              }
            </li>
          );
        })
      }
    </React.Fragment>
  );
};
